export const GuideTypes = {
    SET_GUIDETYPES: "SET_GUIDETYPES",
    ADD_GUIDETYPES: "ADD_GUIDETYPES",
    UPDATE_GUIDETYPES: "UPDATE_GUIDETYPES",
    DELETE_SELECTED_GUIDETYPES: "DELETE_SELECTED_GUIDETYPES",
}